var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19348"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#0744E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8468 11.6618C26.6413 10.7794 28.0255 10.7794 28.82 11.6618L30.8289 13.8932C31.0752 14.1668 31.053 14.5882 30.7793 14.8344C30.5057 15.0806 30.0841 15.0585 29.8378 14.7849L28 12.7436V18.3375C28 18.7055 27.7015 19.004 27.3334 19.004C26.9652 19.004 26.6667 18.7055 26.6667 18.3375V12.7436L24.829 14.7849C24.5827 15.0585 24.1611 15.0806 23.8875 14.8344C23.6138 14.5882 23.5916 14.1668 23.8379 13.8932L25.8468 11.6618ZM16.3334 12.3397C14.1244 12.3397 12.3335 14.1301 12.3335 16.3384V25.6685C12.3335 25.7968 12.3396 25.9235 12.3513 26.0486L13.8631 23.6305C15.5389 20.9501 19.3403 20.6767 21.3826 23.0897L23.1054 25.125C24.6291 22.8243 28.1388 22.7945 29.6664 25.1825V21.0034C29.6664 20.6354 29.9649 20.337 30.3331 20.337C30.7012 20.337 30.9997 20.6354 30.9997 21.0034V25.6685C30.9997 28.613 28.6119 31 25.6665 31H16.3333C13.3878 31 11 28.613 11 25.6685V16.3383C11 13.3938 13.3878 11.0068 16.3333 11.0068H22.1663C22.5345 11.0068 22.833 11.3052 22.833 11.6732C22.833 12.0413 22.5345 12.3397 22.1663 12.3397L16.3334 12.3397Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.460f34b7d50485c1c8f1a2a0933dcf71.svg";
export { ForwardRef as ReactComponent };